/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_kpi_collections14 = /** @type {(inputs: {}) => string} */ () => {
	return `Resources`
};

const fr_kpi_collections14 = /** @type {(inputs: {}) => string} */ () => {
	return `Ressources`
};

const de_kpi_collections14 = /** @type {(inputs: {}) => string} */ () => {
	return `Ressourcen`
};

const es_kpi_collections14 = /** @type {(inputs: {}) => string} */ () => {
	return `Recursos`
};

const it_kpi_collections14 = /** @type {(inputs: {}) => string} */ () => {
	return `Risorse`
};

const ar_kpi_collections14 = /** @type {(inputs: {}) => string} */ () => {
	return `موارد`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const kpi_collections14 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kpi_collections14(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kpi_collections14", locale)
	if (locale === "en") return en_kpi_collections14(inputs)
	if (locale === "fr") return fr_kpi_collections14(inputs)
	if (locale === "de") return de_kpi_collections14(inputs)
	if (locale === "es") return es_kpi_collections14(inputs)
	if (locale === "it") return it_kpi_collections14(inputs)
	return ar_kpi_collections14(inputs)
};
export { kpi_collections14 as "KPI_COLLECTIONS" }